<template>
    <div class="flex flex-center-sp">
        <div class="member-body flex flex-col">
            <div class="margin-top-xxl flex flex-center-sp font-xxl font-bold">升级版本，获得更优质体验</div>
            <div class="flex ">
                <div class="member-level-body margin-right-l  margin-top-xxl flex flex-col flex-center-cz padding-xl">
                    <div class="margin-top-m font-xl font-bold">基础版</div>
                    <div class="margin-top-s font-s color-rgb-05">极简文档分享</div>
                    <div class="font-xxl font-bold" style="margin-top: 40px;">永久免费</div>
                    <div class="margin-top-m  btn-blue-line w120 h25 pointer border-radius-xl">立即使用</div>
                    <div class="flex flex-col margin-top-xxl">
                        <div class="margin-top-s flex flex-center-cz "><img style="width: 22px;height: 22px;"  src="@/assets/images/gou.png"/><span>云端存储文件100个</span></div>
                        <div class="margin-top-s flex flex-center-cz "><img style="width: 22px;height: 22px;"  src="@/assets/images/gou.png"/><span>单个文件最大20M</span></div>
                        <div class="margin-top-s flex flex-center-cz "><img style="width: 22px;height: 22px;"  src="@/assets/images/gou.png"/><span>回收站文件保留7天</span></div>
                        <div class="margin-top-s flex flex-center-cz "><img style="width: 22px;height: 22px;"  src="@/assets/images/gou.png"/><span>访客数据报表</span></div>
                    </div>
                </div>

                <div class="member-level-body margin-left-l  margin-right-l  margin-top-xxl flex flex-col flex-center-cz padding-xl">
                    <div class="margin-top-m font-xl font-bold">高级版</div>
                    <div class="margin-top-s font-s color-rgb-05">无限文件，更大容量</div>
                    <div class="margin-top-l font-s color-rgb-05">低至</div>
                    <div class="margin-top-s font-xxl font-bold" >8.25元/月</div>
                    <div class="margin-top-m  btn-blue-line w120 h25 pointer border-radius-xl">立即购买</div>
                    <div class="font-s font-bold margin-top-s pointer under-line">免费获得高级版</div>
                    <div class="flex flex-col margin-top-xl">
                        <div class="margin-top-s flex flex-center-cz "><img style="width: 22px;height: 22px;"  src="@/assets/images/gou.png"/><span>不限云端文件个数</span></div>
                        <div class="margin-top-s flex flex-center-cz "><img style="width: 22px;height: 22px;"  src="@/assets/images/gou.png"/><span>单个文件最大50M</span></div>
                        <div class="margin-top-s flex flex-center-cz "><img style="width: 22px;height: 22px;"  src="@/assets/images/gou.png"/><span>回收站文件保留30天</span></div>
                        <div class="margin-top-s flex flex-center-cz "><img style="width: 22px;height: 22px;"  src="@/assets/images/gou.png"/><span>支持50G大小云存储空间</span></div>
                        <div class="margin-top-s flex flex-center-cz "><img style="width: 22px;height: 22px;"  src="@/assets/images/gou.png"/><span>访客数据高级报表</span></div>
                    </div>
                </div>

                <div class="member-level-body margin-left-l  margin-top-xxl  flex flex-col flex-center-cz padding-xl">
                    <div class="margin-top-m font-xl font-bold">专业版</div>
                    <div class="margin-top-s font-s color-rgb-05">超强功能</div>
                    <div class="margin-top-l font-s color-rgb-05">低至</div>
                    <div class="margin-top-s font-xxl font-bold" >13.25元/月</div>
                    <div class="margin-top-m  btn-blue-line w120 h25 pointer border-radius-xl">立即购买</div>
                    <div class="flex flex-col margin-top-xl">
                        <div class="margin-top-s flex flex-center-cz "><img style="width: 22px;height: 22px;"  src="@/assets/images/gou.png"/><span>不限云端文件个数</span></div>
                        <div class="margin-top-s flex flex-center-cz "><img style="width: 22px;height: 22px;"  src="@/assets/images/gou.png"/><span>单个文件最大100M</span></div>
                        <div class="margin-top-s flex flex-center-cz "><img style="width: 22px;height: 22px;"  src="@/assets/images/gou.png"/><span>回收站文件保留90天</span></div>
                        <div class="margin-top-s flex flex-center-cz "><img style="width: 22px;height: 22px;"  src="@/assets/images/gou.png"/><span>支持100G大小云存储空间</span></div>
                        <div class="margin-top-s flex flex-center-cz "><img style="width: 22px;height: 22px;"  src="@/assets/images/gou.png"/><span>访客数据高级报表</span></div>
                        <div class="margin-top-s flex flex-center-cz "><img style="width: 22px;height: 22px;"  src="@/assets/images/gou.png"/><span>WORD/PDF文件类型互转</span></div>
                        <div class="margin-top-s flex flex-center-cz "><img style="width: 22px;height: 22px;"  src="@/assets/images/gou.png"/><span>图片合成PDF</span></div>
                    </div>
                </div>                
            </div>
        </div>
    </div>

</template>

<script>
 export default {
    name:'BeMember'
 }
    

</script>

<style scoped>
  .member-body {
    margin-top: 60px;
    margin-bottom: 30px;
    min-height: 500px;

  }
  .member-level-body {
    width: 260px;
    height: 420px;
    background-color: #fff;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

  }

  





</style>


// WEBPACK FOOTER //
// src/views/BeMember.vue